export default function isValidCSSProperty(value, cssProperties) {
  if (typeof value !== 'string') return false;
  return cssProperties.every(prop => {
    let s = new Option().style;
    s[prop] = value;
    return s[prop] !== '';
  });
}
